import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VbAccountUpcomingPayment } from '../../../../../models/transactions/vb-account-upcoming-payment';
import { LumpSumPaymentInstruction } from '../../../../../models/transactions/lump-sum-payment-instruction';

const MAX_UPCOMING_PAYMENTS = 5;

@Component({
  selector: 'app-vb-view-upcoming-payments-modal',
  templateUrl: './vb-view-upcoming-payments-modal.component.html',
  styleUrls: ['./vb-view-upcoming-payments-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbViewUpcomingPaymentsModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);

  private _upcomingPayments: VbAccountUpcomingPayment[] = [];
  private _scheduledLumpSumPayment: LumpSumPaymentInstruction | null = null;

  public displayedPayments: VbAccountUpcomingPayment[] = [];

  public set upcomingPayments(upcomingPayments: VbAccountUpcomingPayment[]) {
    this._upcomingPayments = upcomingPayments;
    this.updateDisplayedPayments();
  }

  public set scheduledLumpSumPayment(scheduledLumpSumPayment: LumpSumPaymentInstruction | null) {
    this._scheduledLumpSumPayment = scheduledLumpSumPayment;
    this.updateDisplayedPayments();
  }

  private updateDisplayedPayments(): void {
    const scheduledLumpSumPayment = this._scheduledLumpSumPayment;

    if (!scheduledLumpSumPayment) {
      this.displayedPayments = this._upcomingPayments;
      return;
    }

    const lumpSumPayment = new VbAccountUpcomingPayment();
    lumpSumPayment.paymentType = $localize`Lump Sum Payment`;
    lumpSumPayment.date = scheduledLumpSumPayment.desiredPaymentDate;
    lumpSumPayment.amount = scheduledLumpSumPayment.paymentAmount;

    const payments = this.containsLumpSumPayment(lumpSumPayment)
      ? this._upcomingPayments
      : [...this._upcomingPayments, lumpSumPayment];

    this.displayedPayments = payments
      .slice()
      .sort((a, b) => a.date.localeCompare(b.date))
      .slice(0, MAX_UPCOMING_PAYMENTS);
  }

  private containsLumpSumPayment(lumpSumPayment: VbAccountUpcomingPayment): boolean {
    const lumpSumPaymentDate = lumpSumPayment.date.split('T')[0];

    return this._upcomingPayments.some(
      payment =>
        payment.paymentType.toLowerCase().includes('lump') &&
        payment.date.split('T')[0] === lumpSumPaymentDate &&
        payment.amount === lumpSumPayment.amount
    );
  }

  public close(): void {
    this.ngbActiveModal.close();
  }
}
